import Form from './Form';
import api from '@/plugins/api';
import { remove } from '@/utils/array';

import component from './component.vue';

export default class TourAdminList {
  component = component;
  form = new Form(this);
  items = [];
  __items = [];
  loading = false;
  dateUpdate = new Date();

  get items() {
    return this.__items;
  }

  set(data) {
    this.__items = data;
  }

  submit() {
    this.loading = true;
    return api.tour.admin
      .list(this.form.data)
      .then((data) => {
        this.set(data.tours?.map(i => ({
          ...i,
          value: i.id,
          label: i.name,
        })) || []);
      }).finally(() => {
        this.loading = false;
      });
  }

  init() {
    this.loading = true;
    return Promise
      .all([
        this.form.init(),
      ])
      .finally(() => {
        this.loading = false;
      });
  }

  del(item) {
    return api.tour.admin
      .del(item.value)
      .then((data) => {
        if(data.IsDeleted)
          remove(this.__items, item);
        return Promise.resolve(data);
      });
  }
}
